/**
 * ListFrame
 *
 * Bordered, internally-scrolling frame that flex-grows to fill its parent's height.
 * Use for a list embedded in a taller layout (workbench pane, split view, dashboard tile).
 * See `.github/context/list-grid-standard.context.md` §2.
 */
import type { FC, PropsWithChildren } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

const useFrameStyles = makeStyles({
  frame: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: '14rem', // ~9 rows — keeps the frame usable when stacked narrow
    overflowY: 'auto',
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
  },
});

export interface ListFrameProps {
  className?: string;
}

export const ListFrame: FC<PropsWithChildren<ListFrameProps>> = ({ className, children }) => {
  const styles = useFrameStyles();
  return <div className={mergeClasses(styles.frame, className)}>{children}</div>;
};
